module.exports = __webpack_public_path__ + "img/00fc113.svg";